
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { UseFormReturn } from 'react-hook-form';
import { cn } from "@/lib/utils";

interface BirthYearFieldProps {
  form: UseFormReturn<any>;
}

const BirthYearField: React.FC<BirthYearFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="birthYear"
      render={({ field }) => (
        <FormItem className="flex flex-col">
          <FormLabel>Birth Year</FormLabel>
          <Popover>
            <PopoverTrigger asChild>
              <FormControl>
                <Button
                  variant={"outline"}
                  className={cn(
                    "w-full pl-3 text-left font-normal",
                    !field.value && "text-muted-foreground"
                  )}
                >
                  {field.value ? (
                    format(field.value, "yyyy")
                  ) : (
                    <span>Select your birth year</span>
                  )}
                  <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                </Button>
              </FormControl>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={field.value}
                onSelect={field.onChange}
                disabled={(date) =>
                  date > new Date() || date < new Date("1900-01-01")
                }
                initialFocus
                className={cn("p-3 pointer-events-auto")}
                defaultMonth={new Date(1980, 0)}
                captionLayout="dropdown-buttons"
                fromYear={1920}
                toYear={new Date().getFullYear() - 10}
              />
            </PopoverContent>
          </Popover>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default BirthYearField;
